export { default } from "./RewardsTotal";
